import { render, staticRenderFns } from "./view-layout.vue?vue&type=template&id=e6ea97f8&scoped=true"
import script from "./view-layout.vue?vue&type=script&lang=js"
export * from "./view-layout.vue?vue&type=script&lang=js"
import style0 from "./view-layout.vue?vue&type=style&index=0&id=e6ea97f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ea97f8",
  null
  
)

export default component.exports